var map = {
	"./board1.jpeg": 2578,
	"./board2.jpeg": 1306,
	"./board3.jpeg": 7310,
	"./boardsAll.jpeg": 9843,
	"./boardsLandscape.jpeg": 6682,
	"./coastlines1.jpg": 6569,
	"./coastlines10.jpg": 7893,
	"./coastlines11.jpg": 7049,
	"./coastlines2.jpg": 1697,
	"./coastlines3.jpg": 3780,
	"./coastlines4.jpg": 7352,
	"./coastlines5.jpg": 8563,
	"./coastlines6.jpg": 1316,
	"./coastlines7.jpg": 3000,
	"./coastlines8.jpg": 8182,
	"./coastlines9.jpg": 7214,
	"./coastlinesLandscape.jpg": 3833,
	"./epoxy1.jpg": 6166,
	"./epoxy10.jpg": 3340,
	"./epoxy11.jpg": 3810,
	"./epoxy12.jpg": 7870,
	"./epoxy2.jpg": 5384,
	"./epoxy3.jpg": 1642,
	"./epoxy4.jpg": 1581,
	"./epoxy5.jpg": 6434,
	"./epoxy6.jpg": 7696,
	"./epoxy7.jpg": 316,
	"./epoxy8.jpg": 8402,
	"./epoxy9.jpg": 3545,
	"./galapagos1.jpg": 3256,
	"./galapagos10.JPG": 7119,
	"./galapagos11.JPG": 5231,
	"./galapagos12.JPG": 9462,
	"./galapagos13.jpg": 1950,
	"./galapagos14.jpg": 5562,
	"./galapagos15.jpg": 6764,
	"./galapagos2.jpg": 1411,
	"./galapagos3.jpg": 9951,
	"./galapagos4.jpg": 2427,
	"./galapagos5.jpg": 711,
	"./galapagos6.jpg": 843,
	"./galapagos7.jpg": 1106,
	"./galapagos8.jpg": 2168,
	"./galapagos9.jpg": 386,
	"./nook1.jpeg": 2512,
	"./nook2.jpeg": 2946,
	"./nook3.jpeg": 5694,
	"./squirrels1.jpeg": 274,
	"./squirrels10.jpeg": 903,
	"./squirrels11.jpg": 9342,
	"./squirrels12.jpeg": 9142,
	"./squirrels13.jpeg": 9852,
	"./squirrels14.jpg": 9176,
	"./squirrels15.jpeg": 7552,
	"./squirrels16.jpeg": 7923,
	"./squirrels17.jpeg": 4257,
	"./squirrels2.jpeg": 8851,
	"./squirrels3.jpeg": 9902,
	"./squirrels4.jpeg": 3101,
	"./squirrels5.jpeg": 6573,
	"./squirrels6.jpeg": 5476,
	"./squirrels7.jpeg": 6952,
	"./squirrels8.jpeg": 7076,
	"./squirrels9.jpeg": 4407,
	"./squirrelsLandscape.jpeg": 1196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5576;